import {scrollEvent} from '@/src/module/jhc-scroll-event';
import {Routing} from '@/src/module/jhc-routing';
import {Cookie} from '@/src/module/jhc-cookie';
import {Modal} from '@/src/module/jhc-modal';
import PageLink from '@/src/module/jhc-pageLink';
import scrollMove from '@/src/module/jhc-scrollMove';
import Accordion from '@/src/module/jhc-accordion';
// import KakaoMap from '@/src/js/KakaoMap';
import React from 'react';
import ReactDOM from 'react-dom';
import UserStatus from '@/src/component/users/log/UserStatus';
import TrialIndex from '@/src/component/trial/TrialIndex';
import TrialItem01 from '@/src/component/trial/TrialItem01';

jhc.Class= {}
export default class Comm extends React.Component {
	constructor (props) {
		super(props);
		this.state= {
			init: false,
			logged: false,
			logInfo: null
		}
	}

	componentDidMount () {
		axios.get('/auth/AuthLogged')
		.then( res=> {
			
			// setTimeout(e=> {

			if( res.data.msg == 'success' ) {
				this.setState({
					init: true,
					logged: true,
					logInfo: res.data.data
				});
			}
			else this.setState({ init: true, logged: false });

			// }, 1000)
		})
		.catch( err=> console.log(err) );
	}

	componentDidUpdate () {
		this.rendering(this.state)
	}

	setDatas= ( param )=> {
		this.setState(param);
	}

	getState= ()=> {
		return this.state;
	}

	rendering (state) {
		console.dir(state)
		ReactDOM.render(
			<UserStatus 
				status={state}
				setDatas={this.setDatas}
				indexClass={this.IndexClass}
			/>,
			document.getElementById('user-info')
		);

		ReactDOM.render(
			<TrialIndex
				IndexClass={this.IndexClass}
				logInfo={state.logInfo}
			>
				<TrialItem01/>
			</TrialIndex>,
			document.getElementById('trial-sect-comm')
		);
	}

	init () {
		this.IndexClass= new IndexClass({
			container: jhc.commElem.container,
			setDatas: this.setDatas,
			getState: this.getState
		});
		const	singleton= function() {}
		singleton.prototype.getInstance= ()=> this.IndexClass;

		const singletone= new singleton()
				,	$IndexClass= singletone.getInstance();
		
		jhc.Class.IndexClass= singletone;
		// jhc.Class.IndexClass= _IndexClass;
		this.IndexClass.run();
	}

	

	render () {
		return <>{this.state.init && this.init()}</>
	}
}




class IndexClass {
	constructor ( props ) {
		this.body= document.body,
		this.props= props;
		this.container= this.props.container,
		this.wrapper= jhc.commElem.wrapper,
		this.headerArea= document.getElementById('head-area'),
		this.topArea= this.headerArea.querySelector('.head-wrapper'),
		this.topScrollBtn= document.getElementById('top-scroll-btn'),

		this.menuCont= document.getElementById('menu-cont'),
		this.trMask= document.getElementById('transition-mask');
		this.menuContArea= document.getElementById('menu-cont-area'),
		this.menuIcon= document.getElementById('menu-icon-area'),
		this.menufull= document.getElementById('menu-content'),
		this.pageLink= document.querySelectorAll('.page-link-comm');

		function checkKeycode(e) {
			let keycode;
			if (window.event) keycode = window.event.keyCode;
			else if (e) keycode = e.which;
			if (keycode == 116) {
				isClose = true;
			}
		}
		
		/* window.addEventListener('beforeunload', e=> {
			// return confirm("Do you really want to close?");
			axios.get('/users/log/LogOut');
		}); */

		function ConfirmLeave() {
			axios.get('/users/log/LogOut');
		}

		window.addEventListener('mouseover', (function () {
			window.onbeforeunload = null;
		}));
		window.addEventListener('mouseout', (function () {
			window.onbeforeunload = ConfirmLeave;
		}));
		
		let prevKey="";
		document.addEventListener('keydown', function (e) {            
			if (e.key=="F5") {
				window.onbeforeunload = null;
			}
			else if (e.key.toUpperCase() == "W" && prevKey == "CONTROL") {                
				window.onbeforeunload = ConfirmLeave;   
			}
			else if (e.key.toUpperCase() == "R" && prevKey == "CONTROL") {
				window.onbeforeunload = null;
			}
			else if (e.key.toUpperCase() == "F4" && (prevKey == "ALT" || prevKey == "CONTROL")) {
				window.onbeforeunload = ConfirmLeave;
			}
			prevKey = e.key.toUpperCase();
		});
		
	}
	

	run () {
		console.log(
			"%c%s%c%s"
			, "color:#fff; background:#333; font-size: 16pt; font-weight: 900; padding: 10px 20px;"
			, '제이에이치크리에이션'
			, "color:#333; background:#D9BD8B;; font-size: 16pt;  font-weight: 900; padding: 10px 20px;"
			, 'JHCreation Inc.'
		);

		jhc.Class.ScrollEvent= this.scrollEvtSingleton();
		this.scrollEvt= jhc.Class.ScrollEvent.getInstance();
		this.routingEvent();

		this.cookieItc= new Cookie();
		
		this.Accordion= new Accordion(this.topArea);
		this.menuEvt();
		this.scrollClickEvt(this.topScrollBtn);

		this.PageLink= new PageLink(this);
		this.PageLink.pageSelect(this.pageLink);
		// this.gmapEvt();
		if(this.popNotice) this.popup();
	}


	menuEvt () {
		this.menuIcon.addEventListener('click', e => {
			if (e.currentTarget.classList.contains('is-active')) this.menuClose();
			else this.menuOpen();
		}, { capture: false });
		this.Accordion.run();
		// this.menuAniCallback();
	}

	menuAniCallback () {
		this.menuContArea.addEventListener('transitionend', e => {
			e.stopPropagation();
			if( e.currentTarget == e.target && e.currentTarget.classList.contains('on') )
				e.currentTarget.style.overflowY= 'auto';
		});
		this.menuContArea.addEventListener('transitionrun', e => {
			e.stopPropagation();
			if( e.currentTarget == e.target && !e.currentTarget.classList.contains('on') )
				e.currentTarget.style.overflowY= 'hidden';
		});
	}
	
	menuOpen () {
		this.menuIcon.classList.add('is-active');
		this.menuContArea.classList.add('on');
	}

	menuClose () {
		this.menuIcon.classList.remove('is-active');
		this.menuContArea.classList.remove('on');
		this.Accordion.allClose();
	}

	routingEvent () {
		this.routing= new Routing({
			wrap: this.wrapper,
			menu: this.menuCont,
			loading: this.trMask,
			routeFile: '/getRoute',
			beforeRender: ( route )=> {
				// console.dir('beforeRender');
			},
			afterRender: ( route )=> {
				const pageLinkElem= this.wrapper.getElementsByClassName('page-link');
				if( pageLinkElem.length > 0 ) this.PageLink.pageSelect(pageLinkElem);

				if( this.routing.currentRouteParam.module ) {
					import( `@/src/js${this.routing.currentRouteParam.module}`)
					.then( m => {
						new m.default(this);
					})
					.catch((err)=> {
						console.dir(err)
					});
				}
				if( this.routing.currentRoute !== '/' ) {
					document.body.classList.add('sub-page');
					import( `@/src/js/tab-render`)
					.then( m => new m.default(this) )
					.catch((err)=> {
						console.dir(err)
					});
				} else {
					document.body.classList.remove('sub-page');
				}
				// console.dir('afterRender')
				this.currentOn= null;
				// this.throttleCB= [];
				var targets= this.wrapper.getElementsByClassName('scroll-active');
				// console.dir(this.scrollEvt)
				this.scrollEvt.reSetElem(targets, {
					// scrollType: 'throttle',
					immediately: (scroll)=> {
						
					},
					throttle: (scroll)=> {
						this.topScrollBtnShow(scroll);
						scroll.currentOnDefault();
						// console.log("%c%s", "color: blue;", 'thrCb');
					},
					currentOnCallback: (scroll)=> {
						this.currentOn && this.currentOn(scroll.passedIndex);
						// console.log("%c%s", "color: green; font-size: 16px;", 'currentOnCallback');
					},
					addReset: (scroll)=> {
						const rect= this.topArea.getBoundingClientRect();
						this.topHeight= rect.height;
					}
				});
				this.scrollEvt.reSet();
			}
		});
		this.routing.config();
	}

	topScrollBtnShow (scroll) {
		if( document.body.scrollHeight > scroll.wininnerHeight ) {
		// if( (document.body.scrollHeight - scroll.windowBottom) < scroll.wininnerHeight ) {
			if( (document.body.scrollHeight - scroll.windowBottom) < 800 ) {
				if( scroll.windowTop < 200 ) this.topScrollBtn.classList.remove('show');
				else this.topScrollBtn.classList.add('show');
			} else {
				this.topScrollBtn.classList.remove('show');
			}
		
			/*if( scroll.windowTop < 200 ) {
				this.headerArea.classList.remove('bg-clr-wh-op4');
			} else {
				this.headerArea.classList.add('bg-clr-wh-op4');
			}*/
		} 
		/*else {
			this.topScrollBtn.classList.remove('show');
		}*/
	}

	scrollEvtSingleton () {
		var scrollEvtInstance= new scrollEvent(document);
		return {
			getInstance: ()=> {
				return scrollEvtInstance;
			}
		}
	}

	popup () {
		// this.cookieItc.deleteCookie('popup');
		this.popBtn= this.popNotice.getElementsByClassName('btn')[0];
		var result = this.cookieItc.getCookie('popup')
			, checkBtn= document.getElementById('popup-notice-close-check');

		if (result == 'end') {
			this.popNotice.innerHTML='';
		   return false;
		} else {
		   this.popNotice.style.display= 'flex';
		}
		
		this.popBtn.addEventListener('click', (e)=> {
			this.popNotice.classList.add('off');
			if( checkBtn.checked ) this.cookieItc.setCookie( "popup", "end" , 1);
		});
	}

	scrollClickEvt ( elem ) {
		elem.addEventListener('click', e => {
			const target= document.getElementById(e.currentTarget.dataset.target);
			scrollMove(target);
		});
	}

	modalClose () {
    this.closeArea.addEventListener('click', (e)=> {
      this.modal.OffModal();
    });
  }

	gmapEvt () {
		var that= this, myLatLng, centerY, centerX;
			
		this.gmapBtn.addEventListener('click', function(e) {
			that.body.classList.add('hidden');
			that.gmapArea.classList.add('show');
		});
		this.gmapClose.addEventListener('click', function(e) {
			that.body.classList.remove('hidden');
			that.gmapArea.classList.remove('show');
		});
	}

}


